import GATSBY_COMPILED_MDX from "/home/runner/work/edbzn.github.io/edbzn.github.io/content/blog/building-an-immutable-store-from-scratch-with-react/index.md";
import {graphql} from 'gatsby';
import React from 'react';
import Giscus from '@giscus/react';
import {MDXProvider} from '@mdx-js/react';
import Bio from '../components/bio';
import Layout from '../components/layout';
import {Note} from '../components/note';
import {PostNav} from '../components/post-nav';
import {Seo} from '../components/seo';
import {rhythm} from '../utils/typography';
const shortcodes = {
  Note
};
class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.mdx;
    const {author, github} = this.props.data.site.siteMetadata;
    const {previous, next} = this.props.pageContext;
    const {location, children} = this.props;
    return React.createElement(Layout, {
      location: location,
      author: author,
      github: github
    }, React.createElement(Seo, {
      title: post.frontmatter.title,
      description: post.frontmatter.description ?? post.excerpt,
      article: true,
      canonical: post.frontmatter.canonical
    }), React.createElement("article", null, React.createElement("header", null, React.createElement("h1", {
      style: {
        marginTop: rhythm(1),
        marginBottom: 0
      }
    }, post.frontmatter.title), React.createElement("p", {
      style: {
        marginTop: rhythm(0.2),
        marginBottom: rhythm(0),
        fontWeight: 'lighter'
      }
    }, post.frontmatter.tags && post.frontmatter.tags.map(tag => React.createElement("span", {
      key: tag
    }, React.createElement("a", {
      href: `/tags/${tag}`,
      style: {
        boxShadow: 'none',
        fontWeight: '400'
      }
    }, "#", tag), ' '))), React.createElement("p", {
      style: {
        marginBottom: rhythm(2),
        fontWeight: 'lighter'
      }
    }, post.frontmatter.draft ? React.createElement("strong", null, React.createElement("span", {
      role: "img",
      "aria-label": "emoji",
      alt: "wip"
    }, "🚧"), ' ', "Draft") : post.frontmatter.date)), React.createElement(MDXProvider, {
      components: shortcodes
    }, React.createElement("section", {
      style: {
        marginBottom: rhythm(2)
      }
    }, children)), React.createElement(Giscus, {
      id: "comments",
      repo: "edbzn/edbzn.github.io",
      repoId: "MDEwOlJlcG9zaXRvcnk5OTQ4MDU0Mw==",
      category: "Comments",
      categoryId: "DIC_kwDOBe3z384CkeQh",
      mapping: "pathname",
      strict: "0",
      reactionsEnabled: "0",
      emitMetadata: "0",
      inputPosition: "bottom",
      theme: "light",
      loading: "lazy",
      lang: "en",
      crossorigin: "anonymous",
      async: true
    }), React.createElement(PostNav, {
      previous: previous,
      next: next
    }), React.createElement("footer", null, React.createElement(Bio))));
  }
}
BlogPostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        author
        github {
          repositoryUrl
          sponsorUrl
        }
      }
    }
    mdx(published: { eq: true }, fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      frontmatter {
        description
        title
        date(formatString: "MMMM DD, YYYY")
        canonical
        draft
        tags
      }
    }
  }
`;
